import { Box } from 'braid-design-system';

import Logo from './Logo/Logo';


const Header = () => (
  <Box
    background="surface"
    data={{ testid: 'header' }}
  >
    <Logo />
  </Box>
);

export default Header;
